/** InsCoder 2024-04-23 B + Hotspot interaction logic **/
document.addEventListener('DOMContentLoaded', () => {
    const hotspots = document.querySelectorAll('.silk-page-hotspots-hotspot');
    const popups = document.querySelectorAll('.silk-page-hotspots__popup');
    const closeButtons = document.querySelectorAll('.silk-page-hotspots__popup__close');
    const popupsContainer = document.querySelector('.silk-page-hotspots__popups');

    hotspots.forEach(hotspot => {
        hotspot.addEventListener('click', () => {
            const index = hotspot.getAttribute('data-index');
            
            // Hide all popups first
            popups.forEach(popup => {
                popup.classList.remove('is-active');
            });
            
            // Show popups container
            if (popupsContainer) {
                popupsContainer.classList.add('is-active');
            }

            // Show clicked popup
            const targetPopup = document.querySelector(`.silk-page-hotspots__popup[data-index="${index}"]`);
            if (targetPopup) {
                targetPopup.classList.add('is-active');
            }
        });
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', () => {
            // Hide all popups
            popups.forEach(popup => {
                popup.classList.remove('is-active');
            });
            
            // Hide popups container
            if (popupsContainer) {
                popupsContainer.classList.remove('is-active');
            }
        });
    });

    if (popupsContainer) {
        popupsContainer.addEventListener('click', (e) => {
            if (e.target === popupsContainer) {
                // Hide all popups
                popups.forEach(popup => {
                    popup.classList.remove('is-active');
                });
                
                // Hide popups container
                popupsContainer.classList.remove('is-active');
            }
        });
    }
});
/** InsCoder 2024-04-23 E + Hotspot interaction logic **/